module.exports = __webpack_public_path__ + "static/media/bg-hotel-spa.c1f194e2.jpg";